import { yup } from 'straightline-utils/validation';
import { addressSchema } from 'straightline-utils/validation/schemas';

const embeddedAddress = addressSchema.shape({
  name: yup.string().trim().label('Company Name').required()
});

export default (app) => {
  return yup.object({
    name: yup.string().trim().label('Address Name').required(),
    address: embeddedAddress.label('Address').required(),
    description: yup.string().trim().label('Description').nullable(),
    default_address: yup
      .string()
      .trim()
      .oneOf(['pickup', 'delivery', null])
      .nullable()
  });
};
